import { FatalDecoratorLimitDescriptorError } from '@rehaje/reactive'
import {
  createMemberDecorator,
  ensureProtoProps,
  isInheritProto
} from '@rehaje/shared'

import { DefaultExposedKeys } from '../constants'
import { ViewModel } from '../models/ViewModel'

import type { MixtureMemberDecorator } from '@rehaje/shared'

/**
 * 声明 getExposedViewModel 不可暴露的 API，用于覆盖 `exposed` 或默认暴露的行为。
 * @example
 * // jsdoc 限制，实际使用请将 * 替换为 @
 * class Parent extends ViewModel {
 *   *exposed()
 *   sharedMethod() {} // 在父类中，此方法是暴露的
 * }
 *
 * class Child extends Parent {
 *   *unexposed()
 *   sharedMethod() {} // 子类可以覆盖父类的行为，将此方法变为不暴露
 * }
 */
export const unexposed: () => MixtureMemberDecorator = createMemberDecorator({
  tsDecorator(proto: ViewModel, key, descriptor) {
    if (!isInheritProto(proto, ViewModel.prototype)) {
      throw new FatalDecoratorLimitDescriptorError(
        'unexposed',
        key,
        'ViewModel'
      )
    }

    const exposedKeys = ensureProtoProps(
      proto,
      '__r_exposed_keys',
      DefaultExposedKeys
    )
    const index = exposedKeys.indexOf(key)
    if (index !== -1) exposedKeys.splice(index, 1)

    return descriptor
  }
})
